import type { ComputedRef } from 'vue';

// Décision « chrome v2 ? » centralisée. Le chrome (sidebar/topbar/shell `.gd-app`) est *dérivé*
// des features de contenu (cf. FEATURES_REQUIRING_CHROME_V2 dans useFeatureVersion) : cette
// résolution `isV2('chrome')` était dupliquée à l'identique dans layouts/default.vue et les pages
// dossier — 3ᵉ répétition atteinte, on extrait le wrapper (règle projet + rapport DS §12.3).
export function useChromeVersion (): { chromeV2: ComputedRef<boolean> } {
  const { isV2 } = useFeatureVersion();
  const chromeV2 = computed(() => isV2('chrome'));
  return { chromeV2 };
}
